import React from 'react';
import { CommunityPlanListItem } from '../../types';
import { HeroImage } from '../common';
import { UnsplashCredit } from '../common/UnsplashCredit';
import './PlanLeaderboard.css';

interface PlanLeaderboardProps {
  plans: CommunityPlanListItem[];
  onPlanClick: (slug: string) => void;
}

const fmt = (n: number) => n >= 1000 ? `${(n / 1000).toFixed(1)}K` : `${n}`;

const PlanLeaderboard: React.FC<PlanLeaderboardProps> = ({ plans, onPlanClick }) => {
  // Ranked by real uses, then the discovery score, then the newest id, so
  // the many plans nobody has used yet still have a deterministic order.
  const sorted = [...plans].sort(
    (a, b) => b.used_count - a.used_count || b.score - a.score || b.id - a.id,
  );

  return (
    <div className="leaderboard">
      <h3 className="leaderboard__title">All Plans · Ranked by Usage</h3>
      {sorted.map((p, i) => (
        /* The credit sits OUTSIDE the row button, beside the thumbnail it
           credits (r774 finding 1). An <a> nested in a <button> is invalid
           markup and the photographer link would not be reachable. */
        <div key={p.id} className="leaderboard__entry">
        <button
          className="leaderboard__row"
          onClick={() => onPlanClick(p.slug)}
        >
          <span className={`leaderboard__rank ${i < 3 ? 'leaderboard__rank--top' : ''}`}>
            {i + 1}
          </span>
          <HeroImage src={p.hero_thumb_url} fallbackKey={p.title} size="thumb-sm" />
          <div className="leaderboard__info">
            <span className="leaderboard__name">{p.title}</span>
            <span className="leaderboard__meta">{p.duration_days} days · {p.destination}</span>
          </div>
          {p.used_count > 0 && (
            <div className="leaderboard__stat">
              <span className="leaderboard__count">{fmt(p.used_count)}</span>
              <span className="leaderboard__label">used</span>
            </div>
          )}
        </button>
          {p.hero_thumb_url && p.hero_attribution && (
            <UnsplashCredit
              photographer={p.hero_attribution.photographer}
              profileLink={p.hero_attribution.unsplash_link}
              className="card-photo-credit"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default PlanLeaderboard;
